const { sameRunStyleInTextBodies } = require('../utils');

exports.computeFontSizeFromTextBodies = (textBodies, textSelection) => sameRunStyleInTextBodies(textBodies, 'font.size', '', { skipUndefined: false, textSelection });
